var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 103,
    viewBox: "0 0 103 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 51.5,
    cy: 51.5,
    r: 51.5,
    fill: "#DEA916"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.9998 70.7832C56.9998 72.5609 55.5587 74.002 53.781 74.002L49.2185 74.002C47.4408 74.002 45.9998 72.5609 45.9998 70.7832L45.9998 68.2207C45.9998 66.443 47.4408 65.002 49.2185 65.002L53.781 65.002C55.5587 65.002 56.9998 66.443 56.9998 68.2207L56.9998 70.7832ZM56.9998 52.7832C56.9998 54.5609 55.5587 56.002 53.781 56.002L49.2185 56.002C47.4408 56.002 45.9998 54.5609 45.9998 52.7832L45.9998 32.2207C45.9998 30.443 47.4408 29.002 49.2185 29.002L53.781 29.002C55.5587 29.002 56.9998 30.443 56.9998 32.2207L56.9998 52.7832Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWarning);
export default __webpack_public_path__ + "static/media/icon-warning.64e92543bac0838f2b45967df00c5cd7.svg";
export { ForwardRef as ReactComponent };